import React from "react";
import AvatarDisplay from "./avatar";
import { fullName } from "./utils";

export function UserDisplay({ user, className }) {
  if (!user) return null;
  
  return (
    <div className={`flex items-center gap-2 ${className || ""}`}>
      <AvatarDisplay className="w-8 h-8" user={user} />
      <span className="text-sm font-medium text-foreground">
        {fullName(user)}
      </span>
    </div>
  );
}
